import styled from "@emotion/styled";
import Image from "../Image";

const TextWithImagesImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export default TextWithImagesImage;
